export enum ApplicationPermissionAction {
	MANAGE_INTERNAL_TEMPLATES = 'manage_internal_templates',
	SHARE_INTERNAL_TEMPLATES = 'share_internal_templates',
	CREATE_INTERNAL_TEMPLATES = 'create_internal_templates'
}